import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import gigplanetTheme from '../../../styles/gigplanetTheme'

const Container = styled.div`
  text-align: left;
  background: #fce6e2;
  padding: ${gigplanetTheme.spacing.small};
  border: 1px solid rgba(10, 10, 10, 0.25);
`

const Heading = styled.h2`
  color: #0a0a0a;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  padding: 0;
`

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`
const Message = styled.li`
  font-size: 14px;
  color: #0a0a0a;
`

const Errormessage = ({ messages }) => {
  if (messages && messages.length === 0) {
    return null
  }
  const messagesElements = messages.map(message => <Message key={message}>{message}</Message>)

  return (
    <Container>
      <Heading>Feilmelding</Heading>
      <List>{messagesElements}</List>
    </Container>
  )
}

Errormessage.propTypes = {
  messages: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
}

export default Errormessage
